import { DateTime, Duration, Intl } from "ts-luxon"
import { DurationUnit } from "ts-luxon/dist/types/duration"

import RelativeTimeFormatUnit = Intl.RelativeTimeFormatUnit

const units: RelativeTimeFormatUnit[] = [
  "year",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second"
]

export const getDateRelative = (date: string) => {
  if (!date) return ""

  const diff: Duration = DateTime.fromISO(date).diffNow().shiftTo(...units)
  const unit: RelativeTimeFormatUnit = units
    .find((unit: DurationUnit) =>
      diff.get(unit) !== 0
    ) || "second"

  const relativeFormatter = new Intl.RelativeTimeFormat("en", {
    numeric: "auto"
  })

  return relativeFormatter.format(Math.trunc(diff.as(unit)), unit)
}
